import React, { useState } from "react";
import { BsArrowRight } from "react-icons/bs";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import useAgent from "../hooks/useAgent";
import Spinner from "../components/Spinner";
import { getText } from '../shared/customization';
import { validatePhone } from "../utils/validation";
import { FlexInputText } from "../components/Flex/FlexInputText";

export default function RegisterAgent() {
  const navigate = useNavigate();
  const { authAgent, isLoading } = useAgent();

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    password: "",
  });

  const { firstName, lastName, phone, email, password } = formData;

  function handleChange(e) {
    setFormData((prevState) => ({
      ...prevState,
      [e.target.id]: e.target.value,
    }));
  }

  async function handleSubmit(e) {
    try {
      e.preventDefault();
      const { success, message } = validatePhone(phone);
      if(!success) {
        toast.error(message);
        return;
      }
      await authAgent(formData);
      navigate("/");
      toast.success("Successful registration");
    } catch (error) {
      console.log("Axios error", { error });
      if (error.code === "auth/email-already-in-use") {
        toast.error("Email already in use");
      } else {
        toast.error("Something went wrong with the registration");
      }
    }
  }

  return (
    <div className="max-w-2xl mx-auto h-[88vh] px-6 md:px-0 font-montserrat flex items-center justify-center ">
      <div>
        <form onSubmit={handleSubmit}>
          <h1 className="font-palatino-lt-serif text-3xl md:text-5xl font-medium uppercase">
            {getText('RegisterAgent.Title')}
          </h1>

          <div className="flex flex-col md:flex-row md:space-x-4 space-y-3 md:space-y-0 mt-8 mb-3 md:mb-8">
            <div>
              <label className="text-sm mb-1" htmlFor="">
                {getText('RegisterAgent.Name')} - <span className="text-gray-500">{getText('RegisterAgent.RequiredField')}</span>
              </label>
              <input
                onChange={handleChange}
                id="firstName"
                value={firstName}
                className="w-full py-2 border border-gray-300 focus:outline-none focus:border-cyan-600
                    pl-4 caret-gray-300"
                type="text"
              />
            </div>

            <div>
              <label className="text-sm mb-1" htmlFor="">
                {getText('RegisterAgent.LastName')} - <span className="text-gray-500">{getText('RegisterAgent.RequiredField')}</span>
              </label>
              <input
                onChange={handleChange}
                id="lastName"
                value={lastName}
                className="w-full py-2 border border-gray-300 focus:outline-none focus:border-cyan-600
                    pl-4 caret-gray-300"
                type="text"
              />
            </div>
          </div>

          <div className="flex flex-col md:flex-row md:space-x-4 space-y-3 md:space-y-0 mb-3 md:mb-8">
            <div className="md:flex-1">
              <label className="text-sm mb-1" htmlFor="">
                {getText('RegisterAgent.Email')} - <span className="text-gray-500">{getText('RegisterAgent.RequiredField')}</span>
              </label>
              <input
                onChange={handleChange}
                id="email"
                value={email}
                className="w-full py-2 border border-gray-300 focus:outline-none focus:border-cyan-600
                    pl-4 caret-gray-300"
                type="text"
              />
            </div>

            <div className="md:flex-1">
              <label className="text-sm mb-1" htmlFor="">
              {getText('RegisterAgent.Phone')} - <span className="text-gray-500">{getText('RegisterAgent.RequiredField')}</span>
              </label>
              <FlexInputText
                id="phone"
                type="phone"
                value={phone}
                onChange={handleChange}
                className="border-gray-300 focus:border-[#18446b] w-full transtion duration-150 ease-in-out disabled:cursor-default disabled:bg-gray-200 disabled:border-gray-200 pl-4"
                maxLength={10}
              />
            </div>
          </div>

          <div className="flex flex-col">
            <label className="text-sm mb-1" htmlFor="">
              {getText('RegisterAgent.Password')} - <span className="text-gray-500">{getText('RegisterAgent.RequiredField')}</span>
            </label>
            <input
              onChange={handleChange}
              id="password"
              value={password}
              className="w-full py-2 border border-gray-300 focus:outline-none focus:border-cyan-600
                pl-4 caret-gray-300"
              type="text"
            />
          </div>

          <div className="flex flex-col md:flex-row md:space-x-4 space-y-3 md:space-y-0 mt-6 mb-3 md:mb-8">
            <button
              type="submit"
              disabled={isLoading}
              className={`uppercase w-full py-3 text-white text-sm font-medium tracking-wider bg-[#18446b] hover:bg-opacity-70 duration-300 ${isLoading ? "bg-slate-300" : ""}`}
            >
              {getText('RegisterAgent.Register')} {isLoading? <Spinner /> : null}
            </button>

            <div className="relative w-full">
              <Link
                to={"/login-agent"}
                className="flex items-center justify-center uppercase w-full py-3 text-black text-sm font-medium tracking-wider
                    border border-transparent hover:border-[#18446b] duration-300"
              >
                {getText('RegisterAgent.SignIn')}
                <BsArrowRight className="ml-2" />
              </Link>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}
